export { default as Vendor } from './data/vendor.mapper';
export { default as VendorService } from './data/vendor.service';
